var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"grid-list-md":"","fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('admin-teacher-list-grid',{attrs:{"professors":_vm.items,"loading":_vm.loading}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }